import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { parseDate } from 'devextreme/localization';
import { DxDateBoxModule } from 'devextreme-angular';
import { SeguimientoService } from 'src/app/services/formulacion/seguimiento.service';
import { UtilHelper } from 'src/app/_helpers/util';

@Component({
  selector: 'app-por-fecha',
  templateUrl: './por-fecha.component.html',
  styleUrls: []
})
export class PorFechaComponent implements OnInit {
  baseUrl = environment.apiEndpoint;
  fecha_inicio = new Date();
  fecha_fin = new Date();
  
  i: string;
  f: string;
  gestion: number = 0;
  hasError: any;
  model: any = {
    fecha_inicio: '',
    fecha_fin: '',
    gestion_id: 0,

  };

  constructor(private _ss: SeguimientoService) {    
    this.resetErrors();
    
  }

  ngOnInit() {
  }

  resetErrors() {

    this.hasError = { fechaC31: false, file: false };
  }

  convertDate2(date: Date) {
    var dd = date.getDate();
    var mm = date.getMonth() + 1;
    let nd = dd.toString();
    let nm = mm.toString();
    var yyyy = date.getFullYear(); if (dd < 10) { nd = '0' + dd } if (mm < 10) { nm = '0' + mm }
    return nd + '/' + nm + '/' + yyyy;
  }

  onChangeFI(e: any) {
    this.i = this.convertDate2(e.value);       
  }

  onChangeFF(e: any) {
    this.f = this.convertDate2(e.value);    
    this.gestion = new Date(this.f).getFullYear();   
    
  }

  getReporteSeguimiento() {

    this.model.fecha_inicio = this.i;
    this.model.fecha_fin = this.f;
    this.model.gestion_id = 6;

    
    this._ss.getRptSeguimientoFisico(this.model).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          
        }
      });

    //window.location.href = "http://localhost/api/xls/seguimientoPOA/?id=5&estado=Completado";

  }

}
